
import Typography from 'typography'
import noriegaTheme from 'typography-theme-noriega'



const typography = new Typography(
    {
        bodyColor: 'white',
        
    }
    ,noriegaTheme)

export default typography
export const rhythm = typography.rhythm